import styled from 'styled-components';

export default styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${p => p.theme.colors.neutral2};
`;
